import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { logger } from 'redux-logger';
import reducer from '../redux';

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const store = createStore(reducer, {}, composeWithDevTools(
  applyMiddleware(...middlewares),
  // other store enhancers if any
));

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js